import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IBundleSelectionProduct } from '@df/catalog/product/bundle-option-selection';
import { BundleSelection } from '@df/catalog/product/bundle-selection';
import { IProductDataV3 } from '@df/catalog/product/product';
import { ImageModule } from '@df/module-image/image.module';
import { CarouselModule } from '@df/ui-carousel/carousel.module';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { IfNotTradeStoreDirective } from 'projects/app-default/src/app/multisite/trade/if-not-trade-store.directive';
import { IfTradeStoreDirective } from 'projects/app-default/src/app/multisite/trade/if-trade-store.directive';
import { LocalProduct } from '../../../../model/product/product.decorator';
import { ShellComponent } from '@df/ui/common/shell/shell.component';
import { ProductBundleOptionsCreateSetComponent } from '../create-set/product-bundle-options-create-set.component';
import { NProductBundleOptions } from '../modal/product-bundle-options-modal.interface';
@Component({
    selector: 'product-bundle-options-selected',
    templateUrl: './product-bundle-options-selected.component.html',
    standalone: true,
    imports: [
        CarouselModule,
        GridModule,
        ICmsClientModule,
        IfNotTradeStoreDirective,
        IfTradeStoreDirective,
        ImageModule,
        ShellComponent,
        TranslationModule
    ],
    styleUrls: ['./product-bundle-options-selected.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductBundleOptionsSelectedComponent extends ProductBundleOptionsCreateSetComponent {
    @Input()
    parent?: LocalProduct<IProductDataV3>;
    @Input()
    override bundleSelection?: BundleSelection;
    override readonly bundleModalId = NProductBundleOptions.MODAL_ID;
    get bundleProducts(): IBundleSelectionProduct[] | undefined {
        return (this.parent.isBundle && this.parent.getBundleSelectedProducts(this.bundleSelection.selection)) || [];
    }
    get bundleProductsImages(): string[] {
        return (
            (this.parent.isBundle &&
                this.parent.getBundleSelectedProducts(this.bundleSelection.selection)?.map(selection => selection.product?.data.image)) ||
            []
        );
    }
}
